export default __webpack_public_path__ + "static/media/module4-page.5ff17bd6.png";